import { clearLocalStorage, resetAllStores, storeResetFns } from './storeRegistry';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthState, User } from '../types/auth';
import { redirectToLogin } from '../lib/navigation';

const authValuesInitialState = {
  user: null,
  token: null,
  authError: null,
  modules: [],
  features: null,
};

const initialState: AuthState = {
  ...authValuesInitialState,
  setUser: () => {},
  handleSessionExpiry: () => {},
  clearSession: () => {},
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => {
      storeResetFns.add(() => set(authValuesInitialState));

      return {
        ...initialState,
        setUser: (user: User | null) => set({ user }),
        clearSession: (redirectPath = '/sign-in') => {
          resetAllStores();
          clearLocalStorage();
          redirectToLogin(redirectPath);
        },
        handleSessionExpiry: ({ redirectPath = '/sign-in?sessionExpired=true' } = {}) => {
          resetAllStores();
          clearLocalStorage();
          redirectToLogin(redirectPath);
        },
      };
    },
    { name: 'authStore',
      partialize: (state) => ({
        // only persist data, not functions
        user: state.user,
        token: state.token,
        authError: state.authError,
        modules: state.modules,
        features: state.features,
      })
     }
  )
);
